import styled from "styled-components/macro";

import { colors } from "UI/colors";

export const Wrapper = styled.div`
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
`;

export const FlyerWrapper = styled.div`
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 20px;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const TitleIcon = styled.div`
  color: ${colors.fnDkBlueGray};
  font-size: 24px;
  margin-right: 8px;
  transform: translateY(-1px);
`;

export const Title = styled.h3`
  color: ${colors.fnDkBlueGray};
  font-weight: 400;
  flex: 1;
  margin: 0;
  line-height: 1.3;
  font-size: 18px;
`;

export const FlyerTitle = styled.h3`
  color: ${colors.fnDkBlueGray};
  font-weight: 600;
  flex: 1;
  margin: 0;
  line-height: 1.3;
  font-size: 18px;
`;

export const Body = styled.div`
  font-size: 14px;
  color: #585858;
`;

export const linkBaseStyles = `
  display: inline-block;
  margin-top: 10px;
  color: ${colors.fnDkBlueGray} !important;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none !important;
  transition: transform 150ms, color 150ms ease-in-out;

  &:hover {
    text-decoration: none !important;
    color: #359ccf !important;
  }
`;

export const Link = styled.a`
  ${linkBaseStyles}
`;
